import React from 'react';
import WarningBox from '../reusable/WarningBox';
import './DataUploadLockedInfo.css';

const DataUploadLockedInfo: React.FC = () => {
  return (
    <div className="data-upload-locked-info">
      <WarningBox title="Data upload locked">
        <p>Contact support for more information.</p>
      </WarningBox>
    </div>
  );
};

export default DataUploadLockedInfo;
